
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./polyfill');
require('./bootstrap');
var numeral = require("numeral");

window.moment = require('moment');

window.momentHoliday = require('./moment-holiday');
momentHoliday.modifyHolidays.set('united_kingdom/EN');

// window.language = document.head.querySelector('meta[name="language"]').content;
// window.channel = document.head.querySelector('meta[name="channel"]').content;
// window.currency = {
//     code: document.head.querySelector('meta[name="currency-code"]').content,
//     symbol: document.head.querySelector('meta[name="currency-symbol"]').content
// };

import PortalVue from 'portal-vue';
import { VLazyImagePlugin } from "v-lazy-image";
import { farewellDirectivePlugin } from 'vue-farewell'

import Vue from 'vue'
import Notifications from 'vue-notification'
// import VueObserveVisibility from 'vue-observe-visibility';

Vue.use(farewellDirectivePlugin)
Vue.use(VLazyImagePlugin);
Vue.use(PortalVue);
Vue.use(Notifications);
// Vue.use(VueObserveVisibility);

//Filters
Vue.filter('capitalize', function (value) {
    if (!value) return '';
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
});

Vue.filter('currency', function (value) {
    if (!value) return currency.symbol + 0.00;
    value = Number(value);
    return currency.symbol + numeral(value).format("0,00.00");
});

Vue.filter("number_format", function (value, divide) {
    if (divide) {
        return numeral(value / 100).format("0,0.00");
    }
    return numeral(value).format("0,0.00");
});

Vue.filter("date", function (value, format) {
    return moment(value).format(format);
});

Vue.filter('truncate', function (text, length, clamp) {
  clamp = clamp || '...';
  var node = document.createElement('div');
  node.innerHTML = text;
  var content = node.textContent;
  return content.length > length ? content.slice(0, length) + clamp : content;
});

Vue.filter("price", function (object, tax, field) {

    let taxAmount = 0,
        fieldHandle = 'price';

    if (field) {
        fieldHandle = field;
    }

    if (object.tax) {
        taxAmount = object.tax;
    }

    let value = object[fieldHandle];

    if (tax) {
        value = value + taxAmount
    }

    return numeral(value / 100).format("0,0.00");
});

String.prototype.titleCase = function () {
    return this.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
};

Vue.component('scroll-top', require('./Components/Elements/ScrollTop.vue'));

Vue.component('site-navigation', require('./Components/SiteNavigation.vue'));
Vue.component('loop54-feed', require('./Components/Loop54Feed.vue'));
Vue.component('loop54-filter', require('./Components/Search/Filters/Loop54/Filter.vue'));

Vue.component('account-menu', require('./Components/Elements/AccountMenu.vue'));
Vue.component('search-listing', require('./Components/Search/SearchListing.vue'));
Vue.component('search-result-card', require('./Components/Search/SearchResultCard.vue'));
Vue.component('site-notification', require('./Components/Elements/Notification.vue'));
Vue.component('tax-toggle', require('./Components/Elements/TaxToggle.vue'));
Vue.component('postcode-lookup', require('./Components/Elements/PostcodeLookup.vue'));
Vue.component('sameday-delivery', require('./Components/Elements/SamedayDelivery.vue'));
Vue.component('next-delivery-date', require('./Components/Elements/NextDeliveryDate.vue'));
Vue.component('country-select', require('./Components/Elements/CountrySelect.vue'));
Vue.component('shipping-badge', require('./Components/Elements/ShippingBadge.vue'));
Vue.component('date-picker', require('./Components/Elements/DatePicker.vue'));
Vue.component('charity-day-modal', require('./Components/Elements/Modals/CharityDayModal.vue'));
Vue.component('date-range', require('./Components/Elements/DateRange.vue'));
Vue.component('email-link', require('./Components/Elements/EmailLink.vue'));
Vue.component('impersonate-bar', require('./Components/Elements/ImpersonateBar.vue'));
Vue.component('seo-truncate', require('./Components/Elements/SeoTruncate.vue'));
Vue.component('login-checker', require('./Components/Elements/LoginChecker.vue'));
Vue.component('login-modal', require('./Components/Elements/Modals/LoginModal.vue'));
Vue.component('farewell-modal', require('./Components/Elements/FarewellModal.vue'));
Vue.component('site-menu', require('./Components/SiteMenu.vue'));
Vue.component('site-banners', require('./Components/SiteBanners.vue'));
Vue.component('corona-message', require('./Components/CoronaMessage.vue'));


/**
 * Search Components
 */

Vue.component('search-sort', require('./Components/Search/SearchSort.vue'));
Vue.component('search-input', require('./Components/Search/SearchInput.vue'));
Vue.component('search-filters', require('./Components/Search/SearchFilters.vue'));

/**
 * Basket components
 */

Vue.component('basket-name', require('./Components/Basket/BasketName.vue'));
Vue.component('postcode-lookup-modal', require('./Components/Elements/Modals/PostcodeLookupModal.vue'));
Vue.component('candy-basket', require('./Components/Basket.vue'));
Vue.component('basket-lines', require('./Components/Basket/BasketLines.vue'));
Vue.component('quick-order', require('./Components/Basket/QuickOrder.vue'));
Vue.component('save-basket', require('./Components/Basket/SaveBasket.vue'));
Vue.component('basket-summary', require('./Components/Basket/BasketSummary.vue'));
Vue.component('empty-basket', require('./Components/Basket/EmptyBasket.vue'));

Vue.component('recommended-products', require('./Components/Product/RecommendedProducts.vue'));

/**
 * Product Components
 */

Vue.component('variant-pricing-help', require('./Components/Product/VariantPricingHelp.vue'));
Vue.component('variant-switcher', require('./Components/Product/VariantSwitcher.vue'));
Vue.component('current-variant', require('./Components/Product/CurrentVariant.vue'));
Vue.component('variant-pricing', require('./Components/Product/VariantPricing.vue'));
Vue.component('stock-level', require('./Components/Product/StockLevel.vue'));
Vue.component('product-gallery', require('./Components/Product/ProductGallery.vue'));

/**
 * Order Components
 */

Vue.component('checkout-steps', require('./Components/Checkout/CheckoutSteps.vue'));
Vue.component('collection-steps', require('./Components/Checkout/CollectionSteps.vue'));
Vue.component('order-summary', require('./Components/Checkout/OrderSummary.vue'));

/**
 * Checkout Components
 */
Vue.component("checkout-btn", require("./Components/Checkout/CheckoutBtn.vue"));
Vue.component("charity-donation", require("./Components/Checkout/CharityDonation.vue"));
Vue.component('catalogue-order', require('./Components/Checkout/CatalogueOrder.vue'));

/**
 * Account Components
 */
Vue.component("account-address", require("./Components/Account/AccountAddress.vue"));
Vue.component("account-addresses", require("./Components/Account/AccountAddresses.vue"));
Vue.component("account-reusable-payment", require("./Components/Account/AccountReusablePayment.vue"));

Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.event = function (event) {
      // here I check that click was outside the el and his childrens
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.event)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.event)
  },
});


Vue.directive('in-view', {
    isLiteral: true,
    update: (el, binding, vnode) => {
      let f = () => {
        let rect = el.getBoundingClientRect()
        let inView = (
          rect.width > 0 &&
          rect.height > 0 &&
          rect.top >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
        )
        if (inView) {
            vnode.context[binding.expression](event);
            window.removeEventListener('scroll', f)
        }
      }
      window.addEventListener('scroll', f)
      f()
    }
});

// Vue.directive('scroll-top', {
//     isLiteral: true,
//     update: (el, binding, vnode) => {
//         const watcher = () => {
//             let rect = e.getBoundingClientRect();
//         }

//         window.addEventListener('scroll', watcher)
//         watcher();
//     }
// })

const app = new Vue({
    el: '#app'
});


// WEBPACK FOOTER //
// ./resources/assets/js/app.js